import { render, staticRenderFns } from "./pay-dialog.vue?vue&type=template&id=3bf9b2cc&scoped=true&"
import script from "./pay-dialog.vue?vue&type=script&lang=js&"
export * from "./pay-dialog.vue?vue&type=script&lang=js&"
import style0 from "./pay-dialog.vue?vue&type=style&index=0&id=3bf9b2cc&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bf9b2cc",
  null
  
)

export default component.exports